import PositiveResponse from './PositiveResponse';

export default PositiveResponse;
